import { adFreeDestinationKind, documentCarriesGoogleTag } from '@/shared/utils/adFreeDestination'
import { useBeforeLeave } from '@solidjs/router'

type LoadDocument = (url: string, replace: boolean) => void

const loadDocument: LoadDocument = (url, replace) => {
  if (replace) {
    window.location.replace(url)
  } else {
    window.location.assign(url)
  }
}

export function useAdFreeNavigationGuard(load: LoadDocument = loadDocument): void {
  useBeforeLeave((e) => {
    if (typeof e.to !== 'string') {
      return
    }
    const url = new URL(e.to, window.location.href)
    if (url.origin !== window.location.origin) {
      return
    }
    // SECURITY: a client-side navigation keeps the Google tag the previous document loaded, so a page the server serves ad-free must be loaded as a new document.
    if (!documentCarriesGoogleTag()) {
      return
    }
    // SECURITY: a dot segment can leave a leading "//" that the browser would load as another host, so only the collapsed same-origin path is ever loaded.
    const target = new URL(
      url.pathname.replace(/\/{2,}/g, '/') + url.search + url.hash,
      window.location.origin
    )
    if (target.origin !== window.location.origin) {
      return
    }
    if (adFreeDestinationKind(target.pathname, target.search) === null) {
      return
    }
    e.preventDefault()
    load(target.pathname + target.search + target.hash, e.options?.replace === true)
  })
}
